// @flow

import * as React from 'react';
import classNames from 'classnames';
import './ResultCard.scss';

type Props = {
  logo: string,
  children: React.Node
}

const ResultCard = ({ logo, children }: Props) => {
  return (
    <div className="result-card">
      <i className={classNames('iconfont', logo)} />
      <div className="results">
        { children }
      </div>
    </div>);
};

export default ResultCard;
